import { isProd } from '@telialt/utils/src/helpers';

import { COVERAGE_MAP_DEV_URL, COVERAGE_MAP_PROD_URL, COVERAGE_MAP_STG_URL } from './constants';

export const getCoverageMapUrl = () => {
    if (typeof window === 'undefined') {
        return isProd() ? COVERAGE_MAP_PROD_URL : COVERAGE_MAP_STG_URL;
    }

    if (isProd()) {
        return COVERAGE_MAP_PROD_URL;
    }

    const hostname = window.location.hostname;
    const [subdomain = ''] = hostname.split('.');
    const isDevEnvironment = subdomain.includes('dev');

    return isDevEnvironment ? COVERAGE_MAP_DEV_URL : COVERAGE_MAP_STG_URL;
};
